function constraintValue(val: number) {
  if (Number.isFinite(val)) {
    return Math.max(0, Math.min(100, val));
  }
  return 0;
}

export default function castPercentageValue(val: unknown): number {
  if (typeof val === 'number') {
    return constraintValue(val);
  }

  if (typeof val === 'string') {
    return constraintValue(Number(val.trim()));
  }

  return 0;
}
